import React, { useCallback } from "react";
import "react-slideshow-image/dist/styles.css";
import "./styles.css";
import "./accessibility.css";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { Slide } from "react-slideshow-image";

const PublicDashboard = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const handleDemoClick = () => {
    window.location.href =
      "mailto:contact@geothara.com?subject=Free Demo Request&body=Hello, I would like to request a free demo of Geothara's services.";
  };

  const prevArrow = (
    <div className="testimonial-arrow" aria-label="Previous testimonial">
      <svg
        viewBox="0 0 32 32"
        className="testimonial-arrow"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20.5 27a1.5 1.5 0 0 1-1.06-.44l-8-8a1.5 1.5 0 0 1 0-2.12l8-8a1.5 1.5 0 1 1 2.12 2.12L15.12 16l6.44 6.44A1.5 1.5 0 0 1 20.5 27z" />
      </svg>
    </div>
  );
  const nextArrow = (
    <div className="testimonial-arrow" aria-label="Next testimonial">
      <svg
        viewBox="0 0 32 32"
        className="testimonial-arrow"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.5 27a1.5 1.5 0 0 1-1.06-2.56L16.88 16l-6.44-6.44A1.5 1.5 0 1 1 12.56 7.44l8 8a1.5 1.5 0 0 1 0 2.12l-8 8A1.5 1.5 0 0 1 11.5 27z" />
      </svg>
    </div>
  );

  const testimonialProperties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: true,
    arrows: true,
    prevArrow,
    nextArrow,
  };

  return (
    <>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: {
            enable: true,
            zIndex: -1,
          },
          background: {
            color: {
              value: "transparent",
            },
          },
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: "#49c1f4",
            },
            shape: {
              type: "circle",
            },
            opacity: {
              value: 0.3,
              random: false,
            },
            size: {
              value: 3,
              random: true,
            },
            links: {
              enable: true,
              distance: 150,
              color: "#49c1f4",
              opacity: 0.2,
              width: 1,
            },
            move: {
              enable: true,
              speed: 1,
              direction: "none",
              random: false,
              straight: false,
              outModes: {
                default: "bounce",
              },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
              onclick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              repulse: {
                distance: 100,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
            },
          },
          retina_detect: true,
        }}
      />

      <header>
        <div className="container header-container">
          <div className="logo">
            <img src="/img/newlogo.png" alt="Geothara Logo" />
            {/* <h1>Geothara</h1> */}
          </div>
          <nav>
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#services">Services</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#horton">Horton Project</a>
              </li>
              <li>
                <a
                  href="https://docs.google.com/document/d/14i1M6lsnaioLJjqzumUQahMo7hBzwut5X7-hPIhGlmA/edit?tab=t.0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </nav>
          <div className="cta-buttons">
            <button
              onClick={() => (window.location.href = "/login")}
              className="btn btn-secondary"
            >
              Sign In
            </button>
            <button onClick={handleDemoClick} className="btn btn-primary">
              Free Demo
            </button>
          </div>
        </div>
      </header>

      <section id="home" className="hero">
        <div className="video-background">
          <video autoPlay muted loop playsInline>
            <source src="/videos/hero-background.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="container">
          <div className="hero-content fade-in">
            <h1>AI for Nature and People</h1>
            <p>
              Geothara offers AI (agentic and other) systems and
              quality-controlled curated data to better understand and make
              descisions around complex changes to Nature and People. Leveraging
              the latest advances in data science and AI tools, Geothara offers
              multi-scale, spatio-temporal insights with unprecedented accuracy,
              detail and speed.
            </p>
            <div className="hero-cta">
              <button onClick={handleDemoClick} className="btn btn-primary">
                Free Demo
              </button>
              <button className="btn btn-secondary">Learn More</button>
            </div>
          </div>
        </div>
      </section>

      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card fade-in">
              <div className="stat-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                  ></path>
                </svg>
              </div>
              <h3>10M+</h3>
              <p>Data Points Analyzed</p>
            </div>
            <div className="stat-card fade-in">
              <div className="stat-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  ></path>
                </svg>
              </div>
              <h3>500+</h3>
              <p>people reached</p>
            </div>
            <div className="stat-card fade-in">
              <div className="stat-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  ></path>
                </svg>
              </div>
              <h3>99.9%</h3>
              <p>Uptime</p>
            </div>
            <div className="stat-card fade-in">
              <div className="stat-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  ></path>
                </svg>
              </div>
              <h3>50+</h3>
              <p>Research Papers</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-title">
            <h2>Our Product, Moat and Solutions</h2>
          </div>
          <div className="features-grid">
            <div className="feature-card fade-in">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                  ></path>
                </svg>
              </div>
              <h3>Trend detection for a changing world</h3>
              <p>
                Our time series and diagnostic, decision-support tools offer a
                step-change improvement with high signal-to-noise in detecting,
                diagnozing and visualizing complex change.
              </p>
              {/* <div className="expand-info">
                <span>Each of these should open more info</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </div> */}
            </div>
            <div className="feature-card fade-in">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  ></path>
                </svg>
              </div>
              <h3>One-click access and ultra-low latency insights</h3>
              <p>
                Our easy-to-use platforms allows our users to gain powerful
                insights about their data in a single click with ultra-low
                latency.
              </p>
              {/* <div className="expand-info">
                <span>Each of these should open more info</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </div> */}
            </div>
            <div className="feature-card fade-in">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  ></path>
                </svg>
              </div>
              <h3>Live collaboration for mapping and video</h3>
              <p>
                Our software comes equipped with built-in live collaboration
                tools, empowering teams to create stunning videos, interactive
                maps, and eye-catching graphics in real time.
              </p>
              {/* <div className="expand-info">
                <span>Each of these should open more info</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="services">
        <div className="container">
          <div className="section-title">
            <h2>Our Services</h2>
          </div>
          <div className="services-grid">
            <div className="service-card fade-in">
              <div className="service-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                  ></path>
                </svg>
              </div>
              <h3>Data Collection, Curation and Augmentation</h3>
              <p>
                We curate a wide range of spatio-temporal and textual data from
                numerous sources and perform AI-based data augmentation
              </p>
            </div>
            <div className="service-card fade-in">
              <div className="service-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  ></path>
                </svg>
              </div>
              <h3>Advanced Analysis of System Insights</h3>
              <p>
                AI- and data science- insights for digital signal processing,
                trend detection, hydro-climate science, corpus linguistics,
                foundational models
              </p>
            </div>
            <div className="service-card fade-in">
              <div className="service-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                  ></path>
                </svg>
              </div>
              <h3>Bespoke Agentic Workflows</h3>
              <p>
                We developed curated solutions to maximize the efficiency of
                collaboration between AI and humans with agentic workflows
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="horton" className="horton-project">
        <div className="container">
          <div className="section-title">
            <h2>The Horton AI Project</h2>
          </div>
          <div className="horton-content">
            <p>
              Data Collection, Curation, and Augmentation We curated one of the
              largest collections of pre-digital scientific documents in
              Hydrology. By integrating library archives, private collections,
              and bibliographic reconstructions, we revived Horton's full
              publication history and augmented it using AI-based OCR, semantic
              indexing, and metadata generation. Advanced Analysis of System
              Insights Geothara's AI models helped analyze Horton's unpublished
              theories on infiltration, runoff, and many more areas of the
              Hydrologic Cycle. These insights were cross-referenced with modern
              tools and methods, unveiling ideas that were decades ahead of
              their time. Bespoke Agentic Workflows We designed custom agentic
              workflows where human and AI experts can collaborate to discover,
              disambiguate, and classify fragmented historical records. This
              human-AI synergy allowed for scalable archival mining without
              sacrificing accuracy or scholarly rigor.
            </p>

            <h3>Publications List</h3>
            <div className="publications-container">
              <table className="publications-table" id="publications-table">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Title</th>
                    <th>Publication</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1896</td>
                    <td>
                      A report for the New York State Engineer and Surveyor
                    </td>
                    <td>New York (State). State Engineer and Surveyor</td>
                  </tr>
                  <tr>
                    <td>1899</td>
                    <td>Runoff and Water Power of Kalamazoo River</td>
                    <td>Water Supply Paper (W.S.P.)</td>
                  </tr>
                  <tr>
                    <td>1900</td>
                    <td>Report of the New York State Engineer and Surveyor</td>
                    <td>New York State Engineer and Surveyor</td>
                  </tr>
                  <tr>
                    <td>1900</td>
                    <td>Computational works connected with hydraulic tests</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1900</td>
                    <td>
                      Report on the measurement of the volume of streams and the
                      flow of water in the State of New York
                    </td>
                    <td>J. B. Lyon, State Printer</td>
                  </tr>
                  <tr>
                    <td>1900</td>
                    <td>On the flow of water over dams</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1900</td>
                    <td>Discussion on "Flow of Water Over Dams"</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1901</td>
                    <td>
                      Available water power of Michigan and its economical
                      development
                    </td>
                    <td>Michigan Engineer</td>
                  </tr>
                  <tr>
                    <td>1901</td>
                    <td>
                      American canal problems, with special reference to the
                      State of New York.
                    </td>
                    <td>Marine Engineering</td>
                  </tr>
                  <tr>
                    <td>1902</td>
                    <td>The law of water as applied to paper mills</td>
                    <td>The Paper Trade Journal</td>
                  </tr>
                  <tr>
                    <td>1902</td>
                    <td>Back-water and Flowage</td>
                    <td>Michigan Engineer</td>
                  </tr>
                  <tr>
                    <td>1902</td>
                    <td>Discussion on Flow of Water in Pipes</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1903</td>
                    <td>
                      Annual Report of the State Engineer and Surveyor of New
                      York
                    </td>
                    <td>
                      Annual Report of the State Engineer and Surveyor of New
                      York
                    </td>
                  </tr>
                  <tr>
                    <td>1903</td>
                    <td>Anchor Ice and Frazil</td>
                    <td>Paper Trade Journal</td>
                  </tr>
                  <tr>
                    <td>1904</td>
                    <td>Power economy in pulp mills</td>
                    <td>The Paper Trade Journal</td>
                  </tr>
                  <tr>
                    <td>1905</td>
                    <td>The drainage of ponds into drilled wells</td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1905</td>
                    <td>
                      Snowfalls, freshets, and the winter flow of streams in the
                      state of New York
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1905</td>
                    <td>
                      Progress of Stream Measurements for the Calendar Year
                      1904, Part 2, Hudson, Passaic, Raritan and Delaware River
                      Drainages
                    </td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1905</td>
                    <td>
                      Report of progress of stream measurements for the calendar
                      year 1904; Part VI, Great Lakes and St. Lawrence River
                      drainage
                    </td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1905</td>
                    <td>
                      Importance of General Hydrographic Data Concerning Basins
                      of Streams Gaged
                    </td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1905</td>
                    <td>Effect of Aquatic Vegetation on Stream Flow</td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>Surface drainage of land by tile</td>
                    <td>Michigan Engineer</td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>Weir experiments, coefficients, and formulas</td>
                    <td>
                      U. S. Geological Survey Water-Supply Paper (First Edition)
                    </td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>Turbine water-wheel tests and power tables</td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>
                      The Surface Streams of Long Island, Underground water
                      resources of Long Island, New York
                    </td>
                    <td>U.S. Geological Survey</td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>
                      Report of progress of stream measurements for the calendar
                      year 1905, Part II, Hudson, Passaic, Raritan, and Delaware
                      River drainages
                    </td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>
                      Report of progress of stream measurements for the calendar
                      year 1905; Part VI, Great Lakes and St. Lawrence River
                      drainages
                    </td>
                    <td>U. S. Geological Survey Water-Supply Paper</td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>
                      Hudson, Passaic, Raritan, and Delaware River Drainages
                    </td>
                    <td>
                      Water-supply and irrigation papers of the United States
                      Geological Survey
                    </td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>Great Lakes and St. Lawrence River drainages</td>
                    <td>
                      Water-supply and irrigation papers of the United States
                      Geological Survey
                    </td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>Streamflow and Water Power Investigation</td>
                    <td>Michigan Engineer</td>
                  </tr>
                  <tr>
                    <td>1906</td>
                    <td>
                      Deforestation, drainage and tillage with special reference
                      to their effect on Michigan streams
                    </td>
                    <td>Michigan Engineer</td>
                  </tr>
                  <tr>
                    <td>1907</td>
                    <td>The Adirondack rainfall summit</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1907</td>
                    <td>
                      Weir experiments, coefficients and formulas (revision)
                    </td>
                    <td>Water Supply Paper (W.S.P.)</td>
                  </tr>
                  <tr>
                    <td>1907</td>
                    <td>
                      Determination of stream flow during the frozen season
                    </td>
                    <td>Water Supply Paper (W.S.P.)</td>
                  </tr>
                  <tr>
                    <td>1907</td>
                    <td>Water level gages</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1907</td>
                    <td>
                      A suggested method of extrapolating values of stream
                      discharge
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1908</td>
                    <td>Waterwheels</td>
                    <td>
                      International Correspondence Schools Reference Library.
                      Scranton, Pa., International Textbook Co.
                    </td>
                  </tr>
                  <tr>
                    <td>1908</td>
                    <td>
                      The adjustment of diversion damages by storage
                      compensation.
                    </td>
                    <td>
                      Journal of the New England Water Works Association (J.
                      N.E.W.W.A.)
                    </td>
                  </tr>
                  <tr>
                    <td>1908</td>
                    <td>Central Station Redevelopment of Water Power</td>
                    <td>
                      Reprinted from General Electric Review - lecture delivered
                      before the Schenectady Section A.I.E.E.
                    </td>
                  </tr>
                  <tr>
                    <td>1909</td>
                    <td>Snowfalls and water equivalents inNew York</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1909</td>
                    <td>
                      The valuation of water power and the estimation of stream
                      diversion damages.
                    </td>
                    <td>
                      Proceedings, American Water Works Association (P.A.W.W.A)
                    </td>
                  </tr>
                  <tr>
                    <td>1910</td>
                    <td>The turbine waterwheel as a prime mover</td>
                    <td>Clarkson Bulletin</td>
                  </tr>
                  <tr>
                    <td>1910</td>
                    <td>
                      Correspondence. Statistical and Experimental Data on
                      Filtration and the Sheffield Water Supply and Statistics
                      Relating Thereto
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1910</td>
                    <td>
                      "Discussion on, ""Statistical and experimental data on
                      filtration"""
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1911</td>
                    <td>Ebermayer's experiments on forest meteorology</td>
                    <td>Michigan Engineer</td>
                  </tr>
                  <tr>
                    <td>1912</td>
                    <td>
                      Discussion on, "Investigations relating to the yield of a
                      catchment-area in Cape Colony by Barnard C. Bartlett"
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1912</td>
                    <td>
                      Discussion on, "The works for the supply of water to the
                      City of Birmingham from Mid-Wales"
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1912</td>
                    <td>
                      Correspondence. Water Supply in South Africa (Including
                      Appendix)
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1913</td>
                    <td>
                      Effects of recent flood on New York streams; study of
                      rainfall and stream discharge, with hydrographs for
                      fourteen rivers
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1913</td>
                    <td>Flood frequency and flood control</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1913</td>
                    <td>Effects of recent floods on New York streets</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>1913</td>
                    <td>Floods in New York</td>
                    <td>ENR, republished in a report</td>
                  </tr>
                  <tr>
                    <td>1913</td>
                    <td>
                      Supplemental Note on Frequency of Recurrence of Hudson
                      River Floods
                    </td>
                    <td>U.S. Weather Bureau Bull. Z</td>
                  </tr>
                  <tr>
                    <td>1913</td>
                    <td>Water Power and Water Supply Preliminaries</td>
                    <td>Engineering Record, Michigan Engineering</td>
                  </tr>
                  <tr>
                    <td>1913</td>
                    <td>
                      Discussion on, "The yield of various catchment areas in
                      Scotland" by William C. Reid and Edward Sandeman
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>
                      Evaporation from snow and errors of rain gage when used to
                      catch snowfall
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>
                      Discussion of Report of Committee on "Yield of Drainage
                      Areas"
                    </td>
                    <td>
                      Journal of the New England Water Works Association (J.
                      N.E.W.W.A.)
                    </td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>
                      Discussion on, "Derivation of runoff from rainfall data"
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>Need for simpler and more definite water laws</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>
                      Discussion on, "Measurement of the flow of streams by
                      approved forms of weirs" by Richard R. Lyman
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>
                      Discussion on, "Measurement of the flow of the River
                      Derwent, Derbyshire, England" by William C. Reid and
                      Edward Sandeman
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>Discussion on, "Flood Flows"</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>Errata on, "Flood Flows"</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1914</td>
                    <td>Discussion on Rainfall and Run-Off</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>Idiosyncrasies of Underground Water</td>
                    <td>Proc. Connecticut Society of Civil Engineers</td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>The melting of snow</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>
                      Discussion of paper by Adolf F. Meyer on Computing Runoff
                      from Rainfall and other Physical data
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>Discussion: Yield of Underground Reservoirs</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>
                      Economic Considerations Justify Wood-stave Pipe for
                      Water-Power Penstocks.
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>
                      High coefficient of roughness for natural river channels
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>
                      Discussion on, "A method of determining storm-water
                      run-off" by Charles B. Buerger
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>
                      Discussion on, "Some principles relating to the
                      administration of streams by C. T. Johnson"
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>
                      Discussion: "A Method of Determinating Storm-Water
                      Run-Off" by Charles B. Buerger
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>Discussion on Stream Administration</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>Discussion: Yield of Underground Reservoirs</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1915</td>
                    <td>
                      Discussion: "Computing runoff from rainfall and other
                      physical data" by Adolph Mayer
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>Standing-wave experiment</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>Some better Kutter's formula coefficients</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>Old Brick Intake Tunnel Shows Low Kutter Factor</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>Diagram for full comparison of hydraulic turbines</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>
                      Discussion on, "A study of the depth of annual evaporation
                      from Lake Conchos, Mexico" by Edwin Duryea and H.L. Haehl
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>Discussion: Evaporation from Lake Conchos, Mex.</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>Discussion on the Action of Water under Dams</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1916</td>
                    <td>
                      Discussion on "Chemi-hydrometry and its applicationto the
                      precise testing of hydro-electric generators"
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1917</td>
                    <td>A new evaporation formula</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1917</td>
                    <td>A new evaporation formula developed</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1917</td>
                    <td>
                      Failure of hydraulic projects from lack of water prevented
                      by better hydrology
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1917</td>
                    <td>
                      Rational study of rainfall data makes possible better
                      estimates of water yield
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1917</td>
                    <td>
                      Drainage Basin and Crop Studies Aid Water-Supply Estimates
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1918</td>
                    <td>
                      Determining the regulating effect of a storage reservoir
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1918</td>
                    <td>Air chimneys of ice below a waterfall</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1918</td>
                    <td>Discussion on "obstruction to flow by bridge piers"</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1919-I</td>
                    <td>Additional meteorological data needed by engineers</td>
                    <td>
                      Engineering News-Record (E.N.R.) , Monthly Weather Review
                      (M.W.R.)
                    </td>
                  </tr>
                  <tr>
                    <td>1919-II</td>
                    <td>Additional meteorological data needed by engineers</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1919-I</td>
                    <td>The measurement of rainfall and snow</td>
                    <td>
                      Journal of the New England Water Works Association
                      (J.N.E.W.W.A.), Canadian Engineer
                    </td>
                  </tr>
                  <tr>
                    <td>1919-II</td>
                    <td>The measurement of rainfall and snow</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1919-I</td>
                    <td>
                      Some Broader Aspects of Rain Intensities in Relation to
                      Storm Sewer Design
                    </td>
                    <td>Municipal and County Engineering</td>
                  </tr>
                  <tr>
                    <td>1919-II</td>
                    <td>
                      Some Broader Aspects of Rain Intensities in Relation to
                      Storm-Sewer Design - Shorter Version
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>
                      Watershed Leakage in Relation to Gravity Water Supplies
                    </td>
                    <td>Journal of the New England Water Works Association</td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>Rainfall interception</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1918</td>
                    <td>
                      Discussion: Obstruction to Flow by Bridge Piers by Floyd
                      A. Nagler
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>
                      Discussion on "Precipitation and runoff in the drainage
                      basin of the Oder" by Karl Fischer
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>Evaporative capacity</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>
                      Device for obtaining maximum and minimum water surface
                      temperatures
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>
                      Discussion on "The distribution of maximum floods" by A.
                      J. Henry
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>
                      Discussion on The Duty of Water In the Pacific Northwest
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>
                      Water Expectancy in Tunnels, Mines and Deep Wells in
                      Homogenous Rocks
                    </td>
                    <td>
                      Journal of American Water Works Association (J.A.W.W.A.)
                    </td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>Form and Area Factors for Evaporation</td>
                    <td>
                      Monthly Weather Review (Abstract from Meteorologische
                      Zeitschrift)
                    </td>
                  </tr>
                  <tr>
                    <td>1919</td>
                    <td>
                      Variation of roughness coefficient in Manning and Kutter's
                      Formulas
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>Discussions, "Rrainfall at Muscatine, Iowa"</td>
                    <td>Journal - American Water Works Association</td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>From the Committees: Hydrological Meteorology</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>
                      Comparison of snow-board and raingage-can measurements of
                      snowfall
                    </td>
                    <td>Reprinted from Engineerings News-Record</td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>Water Power</td>
                    <td>The Encyclopedia Americana</td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>Modern Developments in Hydraulic Turbine Design</td>
                    <td>Reprinted from Engineerings News-Record</td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>
                      Comparison of snowboard and rain-gage can measurements of
                      rainfall
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>Weather and literature</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1920</td>
                    <td>
                      The influence of forest areas in non-forested regions upon
                      evaporation, soil-moisture andmovement of ground-water
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>The depletion of ground-water supplies</td>
                    <td>
                      Journal of the American Water Works Association (J.
                      A.W.W.A.)
                    </td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>
                      Cloudburst rainfall at Taborton, N.Y., August 10, 1920
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>Vapor pressure and humidity diagram</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>Results of Evaporation Observations</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>
                      Correlation of maximum rain intensities for long and short
                      time-intervals
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>
                      Discussion of the probable variation in yearly
                      precipitation
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>
                      Discussion of "Probable Variations in Yearly Run-off" by
                      L. Standish Hall
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>
                      Errata: Discussion of Probable Variations in Yearly
                      Run-off
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>Thunderstorm-breading spots</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>The beginning of a thunderstorm</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>Note on evaporation from reservoirs</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>Unusual lightning</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1921</td>
                    <td>The first year of the society (AMS)</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1922</td>
                    <td>
                      The Second Year of the Society: Committee on Engineering
                      Meteorology and Hydrology
                    </td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1922</td>
                    <td>Elevation and latitude</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1922</td>
                    <td>Discussion of "Siphon Spillways" by G.F. Stickney</td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1922</td>
                    <td>
                      Discussion of "The American Mixed-Flow Turbine and its
                      Setting" by B. F. Groat
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1922-I</td>
                    <td>A farmer's phenological records</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1922-II</td>
                    <td>A farmer's phenological records</td>
                    <td>Engineering Foundation Research Narratives</td>
                  </tr>
                  <tr>
                    <td>1922</td>
                    <td>Pattern-shop Research</td>
                    <td>Engineering Foundation Research Narratives</td>
                  </tr>
                  <tr>
                    <td>1923</td>
                    <td>
                      Discussion of Gorbatchev's "Relation between duration,
                      intensity, and periodicity of rainfall"
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1923</td>
                    <td>Transpiration by forest trees</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1923</td>
                    <td>Rainfall interpolation</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1923-07</td>
                    <td>Accuracy of areal rainfall estimates</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1923-07</td>
                    <td>Rainfall duration and intensity in India</td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1923-10</td>
                    <td>
                      Group distribution and periodicity of annual rainfall
                      amounts
                    </td>
                    <td>Monthly Weather Review (M.W.R)</td>
                  </tr>
                  <tr>
                    <td>1923</td>
                    <td>Engineering Meteorology and Hydrology</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1923</td>
                    <td>Correction from the committees</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>Determining mean precipitation on a drainage basin</td>
                    <td>
                      Journal of the New England Water Works Association
                      (J.N.E.W.W.A.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>
                      Discussion of "The distribution of intense rainfall and
                      some other factors in the design of storm-water drains,"
                      by Frank A. Marston
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>Flood reduction by reservoirs</td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>
                      Discussion of paper by C. S. Jarvis on flood flow
                      characteristics
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>
                      Precipitation and Runoff near the Continental Divide
                    </td>
                    <td>Engineering News-Record (E.N.R.)</td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>
                      Discussion on, "Discharge from catchment areas in India as
                      affecting the waterways of bridges" by Col. G. R. Haern
                      and George E. Lillie
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>
                      Correspondence on, "FLOODS OF THE DAMODAR RIVER, AND
                      RAINSTORMS PRODUCING THEM."
                    </td>
                    <td>
                      Proceedings, Institution of Civil Engineers (P.I.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>
                      The probable variations in yearly run-off as determined
                      from a study of California streams
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>
                      Report on the lake lowering controversy and a program of
                      remedial measures
                    </td>
                    <td>
                      Engineering Board of Review of the Sanitary District of
                      Chicago
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>A double-breasted Thunderstorm</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1924</td>
                    <td>Committee on Engineering Meteorology and Hydrology</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>1926</td>
                    <td>
                      Report on Hannacrois-Catskill gravity water supply for the
                      city of Albany, N.Y
                    </td>
                    <td>Albany (N.Y.). Board of Water Supply.</td>
                  </tr>
                  <tr>
                    <td>1926</td>
                    <td>
                      Discussion of "Follansbee on Flood Flow Characteristics"
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1927</td>
                    <td>Hydrology of the Great Lakes</td>
                    <td>
                      Report of the Engineering Board of Review of the Sanitary
                      District of Chicago
                    </td>
                  </tr>
                  <tr>
                    <td>1927</td>
                    <td>
                      Report on the lake lowering controversy and a program of
                      remedial measures
                    </td>
                    <td>
                      Hydrology of the Great Lakes, Sanitary district of
                      Chicago. Eng. bd. of review
                    </td>
                  </tr>
                  <tr>
                    <td>1927</td>
                    <td>Stream Gauging by the Current Meter</td>
                    <td>
                      Engineering Literature: A monthly review of books and a
                      listing of new publications
                    </td>
                  </tr>
                  <tr>
                    <td>1928</td>
                    <td>
                      Report on proposed tri-state compact [to] Board of
                      Commissioners
                    </td>
                    <td>Dept. of Public Works</td>
                  </tr>
                  <tr>
                    <td>1929</td>
                    <td>
                      Always a user of cast-iron pipes - some causes of breaks
                    </td>
                    <td>E.N.R.</td>
                  </tr>
                  <tr>
                    <td>1929</td>
                    <td>
                      A program for regulation and conservation of the Delaware
                      River
                    </td>
                    <td>Trenton, N.J.</td>
                  </tr>
                  <tr>
                    <td>1931</td>
                    <td>
                      Field, scope and status of hydrology, Water and Water
                      Engineering
                    </td>
                    <td>Dept. of Public Works, Trenton, N.J.</td>
                  </tr>
                  <tr>
                    <td>1931</td>
                    <td>
                      Discussion of "Effect of Turbulence on Current Meters" by
                      David L. Yernell and Floyd A. Nagler
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1931</td>
                    <td>
                      Discussion of "Bennett on Effect of Turbulence on Current
                      Meters"
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1931</td>
                    <td>
                      Discussion of "Regulation of levels, flow and navigation,
                      Niagara River"
                    </td>
                    <td>
                      Transactions of the American Society of Civil Engineers
                      (T.A.S.C.E.)
                    </td>
                  </tr>
                  <tr>
                    <td>1931</td>
                    <td>New gravity water-supply system of Albany, N. Y.</td>
                    <td>Journal of the New England Water Works Association</td>
                  </tr>
                  <tr>
                    <td>1931-I</td>
                    <td>
                      The field, scope and status of the science of hydrology
                    </td>
                    <td>Transactions of the American Geophysical Union</td>
                  </tr>
                  <tr>
                    <td>1931-II</td>
                    <td>
                      The field, scope and status of the science of hydrology
                    </td>
                    <td>W. and W. Eng.</td>
                  </tr>
                  <tr>
                    <td>1932</td>
                    <td>Drainage basin characteristics</td>
                    <td>Eos Trans. AGU</td>
                  </tr>
                  <tr>
                    <td>1932</td>
                    <td>
                      Water diversion between drainage basins [with discussions]
                    </td>
                    <td>American Water Works Association Journal</td>
                  </tr>
                  <tr>
                    <td>1932</td>
                    <td>
                      Discussion of the Report of the Committee on Floods of the
                      Boston Society of Civil Engineers
                    </td>
                    <td>Boston Society of Civil Engineers Journal</td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>
                      Relation of stream flow to annual seasonal or monthly
                      rainfall
                    </td>
                    <td>
                      Prepared for the Lisbon Meeting of the Section of
                      Hydrology, International Geophysical Union
                    </td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>The role of infiltration in the hydrologic cycle</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>Storm-flow prediction</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>The relation of hydrology to the botanical sciences</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>
                      Slope table for fully controlled hydraulic experiments in
                      open channels
                    </td>
                    <td>W. and W. Eng.</td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>Primary Rainfall Types</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>Columnar Vapor Drift</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>
                      Separate roughness coefficients for channel bottom and
                      sides
                    </td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1933</td>
                    <td>Rainfall, Runoff and Evaporation</td>
                    <td>
                      Prepared for the Lisbon Meeting of the Section of
                      Hydrology, International Geophysical Union
                    </td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>The Italian Hydrologic Service</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>Discharge coefficients for tainter gates</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>
                      Compilation and summary of the evaporation records of the
                      Bureau of Plant Industry, U.S. Department of Agriculture,
                      1921-32
                    </td>
                    <td>Monthly Weather Review</td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>Snow-surface temperature</td>
                    <td>Monthly Weather Review</td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>
                      Water-losses in high latitudes and at high elevations
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>Laminar sheet flow</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>
                      Recent tendencies in relation to valuation of water rights
                    </td>
                    <td>American Water Works Association Journal</td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>
                      Conservation and use of water on farms in humid regions
                    </td>
                    <td>National Resources Board</td>
                  </tr>
                  <tr>
                    <td>1934</td>
                    <td>Composite roughness in channels</td>
                    <td>Engineering News Record (E.N.R)</td>
                  </tr>
                  <tr>
                    <td>1935</td>
                    <td>
                      Surface runoff phenomena : Part I, Analysis of the
                      hydrograph
                    </td>
                    <td>Edwards Brothers, Inc.</td>
                  </tr>
                  <tr>
                    <td>1936</td>
                    <td>
                      Discussion on, "Recent Developments in British Waterworks
                      Practice" by Harold J. F. Gourley
                    </td>
                    <td>Journal of New England Water Works Association</td>
                  </tr>
                  <tr>
                    <td>1936</td>
                    <td>
                      Relation of Hydraulic and Laboratory Resaerch to Physical
                      and Economic Geography
                    </td>
                    <td>Assoc. Int. Hyd. Sci., Edinburgh</td>
                  </tr>
                  <tr>
                    <td>1936</td>
                    <td>Natural stream-channel storage</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1936</td>
                    <td>Maximum groundwater levels</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1936</td>
                    <td>
                      Phenomena of the contact zone between the ground surface
                      and a layer of melting snow.
                    </td>
                    <td>
                      Transactions of the International Commission of Snow and
                      Ice
                    </td>
                  </tr>
                  <tr>
                    <td>1936</td>
                    <td>
                      Surface-runoff control, Headwaters Control and Use,
                      Chapter II
                    </td>
                    <td>
                      Soil Conservation Service and Forest Service of the United
                      States Department of Agriculture
                    </td>
                  </tr>
                  <tr>
                    <td>1936</td>
                    <td>
                      Historical development of ideas regarding the origin of
                      springs and ground water
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Ice formation on Streams</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>The Effect of Ice on Streamflow Measurement</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Ice piecrusts</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>The Effect of Soil Frost on Runoff</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Methods and objectives of hydrologic research.</td>
                    <td>
                      Water Resources Committee of the National Resources
                      Committee, Washington, D. C.
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Hydrologic research</td>
                    <td>Science</td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>
                      Hydrologic conditions as affecting the results of the
                      application of methods of frequency analysis to flood
                      records
                    </td>
                    <td>Floods in the UnitedStates, W.S.P.</td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Hydrologic Interrelations of Water and Soils</td>
                    <td>Proc. Soil Sci. Soc. Am</td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Surface runoff control</td>
                    <td>Upstream Engineering Conference, Washington, D.C.</td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Natural stream channel-storage (Second paper)</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>
                      Determination of infiltration capacity for large drainage
                      basins
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>Hydrologic aspects of stream-flow stabilization</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>
                      Hydrologic aspects of the problem of stabilizing stream
                      flow
                    </td>
                    <td>Journal of Forestry</td>
                  </tr>
                  <tr>
                    <td>1937</td>
                    <td>List of Publications with Abstracts</td>
                    <td>Horton Hydrologic Laboratory</td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      List of Publications 112-122 with Abstracts, Supplement
                      No. 1
                    </td>
                    <td>Horton Hydrologic Laboratory</td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>Definitions and classification of flood waves</td>
                    <td>
                      Bulletin of the Permanent International Association of
                      Navigation Congresses, no. 25
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      Preliminary outline for a comprehensive research on runoff
                      phenomena
                    </td>
                    <td>
                      The Water Resources Committee of the NationalResources
                      Committee, Washington, D. C.
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      Analysis of sprinkled plat surface runoff experiments
                    </td>
                    <td>
                      Soil Conservation Service in cooperation with the Horton
                      Hydrologio Laboratory
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>Muskingum rainfall maps</td>
                    <td>
                      The Section of Climatic and Physiographic Research,
                      Division of Research,Soil Conservation Service,
                      Washington, D. C.
                    </td>
                  </tr>
                  <tr>
                    <td>1938-I</td>
                    <td>Channel waves subject chiefly to momentum control</td>
                    <td>
                      U.S. Dept. of Agriculture, Soil Conservation Service , and
                      Horton Hydrologic Laboratory
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>Rain wave-trains</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      Seddon's and Forchheimer's formulas for crest velocity of
                      flood-waves subject to channel-friction control
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      Phenomena of the contact zone between the ground surface
                      and a layer of melting snow
                    </td>
                    <td>International Association of Scientific Hydrology</td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      Report on Soil Conservation Service special advisory
                      committee, 1937-1938
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>Analysis of simulated rainfall experiments</td>
                    <td>
                      U.S. Dept. of Agriculture, Soil Conservation Service
                    </td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      The interpretation and application of runoff experiments
                      with reference to soil erosion problems
                    </td>
                    <td>Proceedings of the Soil Science Society of America</td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>Apples from Eden and other short stories</td>
                    <td>Christopher Publication House</td>
                  </tr>
                  <tr>
                    <td>1938</td>
                    <td>
                      Appendix B-Report of Subcommittee on Bibliography of
                      Special Committee on Flood-Waves
                    </td>
                    <td>Transactions American Geophysical Union (T.A.G.U)</td>
                  </tr>
                  <tr>
                    <td>1939</td>
                    <td>
                      Memorandum regarding purpose and procedure for research
                      project on infiltration [in Delaware River]
                    </td>
                    <td>
                      Interstate Commission on the Delaware River Basin,
                      Philadelphia
                    </td>
                  </tr>
                  <tr>
                    <td>1939</td>
                    <td>
                      Analysis of runoff-plat experiments with varying
                      infiltration capacity
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1939</td>
                    <td>
                      Hydrologic advisory committee to the Research Division of
                      the United States Soil Conservation Service, 1938-1939
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1939</td>
                    <td>What Can We Do About the Weather?</td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1939</td>
                    <td>
                      Relation of Soil-moisture and Antecedent Rainfall to
                      Run-off and Run-off Prediction
                    </td>
                    <td>
                      to be published in Trans. International Commission on Snow
                      and Ice. General Assembly, International Geophysical
                      Union, Washington, 1939
                    </td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>
                      Hydrologic advisory committee to the Research Division of
                      the United States Soil Conservation Service, 1939-1940
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>The infiltration-theory of surface-runoff</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>
                      Hydrophysical approach to quantitative morphology of
                      drainage basins
                    </td>
                    <td>Geological Society of America Bulletin</td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>
                      An approach toward a physical interpretation of
                      infiltration capacity
                    </td>
                    <td>Proceedings of the Soil Science Society of America</td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>
                      Suggestions for a Comprehensive Research on Run-off
                      Phenomena: Appendix C
                    </td>
                    <td>National Research Planning Board</td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>Delaware River Basin Flood Volumes, n. 1</td>
                    <td>
                      Interstate Commission on Delaware River Basin Series C
                    </td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>
                      Determination of areal average infiltration-capacity from
                      rainfall and runoff data
                    </td>
                    <td>
                      U.S. Dept. of Agriculture, Soil Conservation Service
                    </td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>
                      Sprinkled Plat Runoff and Infiltration Experiments on
                      Arizona Desert Soils
                    </td>
                    <td>
                      Office of Land Use Coordination, U.S. Dept. of
                      Agriculture, Soil Conservation Service
                    </td>
                  </tr>
                  <tr>
                    <td>1940</td>
                    <td>
                      Diagrams showing seasonal flood characteristics of
                      principal rivers in the United States.
                    </td>
                    <td>U.S. Dept. of Agriculture, Washington, D.C.</td>
                  </tr>
                  <tr>
                    <td>1941</td>
                    <td>
                      The Role of Snow, Ice and Frost in the Hydrologic Cycle
                    </td>
                    <td>East Lansing</td>
                  </tr>
                  <tr>
                    <td>1941</td>
                    <td>Flood-crest reduction by channel storage</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1941</td>
                    <td>Sheet erosion: past and present</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1941</td>
                    <td>Virtual channel-inflow graphs</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1941</td>
                    <td>
                      Hydrologic advisory committee to the Research Division of
                      the United States Soil Conservation Service
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1941</td>
                    <td>
                      Discussion (in response to N. E. Edlefsens, Report of the
                      committee on the physics of soil-moisture, 1940-1941, pp.
                      917-926)
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1941</td>
                    <td>
                      Discussion (in response to M. R. Huberty and A. F.
                      Pillsbury, Factors influencing infiltration-rates into
                      some California soils, pp. 686-693)
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      Discussion (in response to A. B. C. Anderson, J. E.
                      Fletcher, and N. E. Edlefsen, Soil-moisture conditions and
                      phenomena in frozen soils, pp. 356-364)
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      Derivation of infiltration-capacity curve from
                      infiltrometer experiments
                    </td>
                    <td>
                      U.S. Dept. of Agriculture, Office of Land Use
                      Coordination, Flood Control
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      Hydrologic advisory committee to the Research Division of
                      the United States Soil Conservation Service, 1941-1942
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>Remarks on hydrologic terminology</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>An experiment on flow through a capillary tube</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      Closure to discussion (in response to Horton, R. E., An
                      experiment on flow through a capillary tube, pp. 534-538)
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      Simplified method of determining an infiltration-capacity
                      curve from an infiltrometer-experiment
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      A simplified method of determining the constants of the
                      infiltration-capacity equation
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      Some effects of rain erosion and sedimentation on
                      infiltration-capacity
                    </td>
                    <td>Proceedings of the Soil Science Society of America</td>
                  </tr>
                  <tr>
                    <td>1942</td>
                    <td>
                      Report of Advisory Committee on Soil-Conservation
                      Research, 1941–42
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1943</td>
                    <td>Evaporation—Maps of the United States</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1943</td>
                    <td>Hydrologic interrelations between lands and oceans</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1943</td>
                    <td>
                      On the relation of soil conservation to air and
                      ground-water pollution
                    </td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1943</td>
                    <td>
                      Notas sobre la relación entre la conservación del suelo y
                      la contaminación del aire y aguas subterraneas
                    </td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1943</td>
                    <td>
                      A discussion of the relation of soil conservation to air
                      and ground-water pollution
                    </td>
                    <td>
                      Bulletin of the American Meteorological Society (B.A.M.S.)
                    </td>
                  </tr>
                  <tr>
                    <td>1944</td>
                    <td>
                      Report on proposed improvement and extension of Hemlock
                      Lake water supply system, Rochester, N.Y
                    </td>
                    <td>City of Rochester, N. Y.</td>
                  </tr>
                  <tr>
                    <td>1944</td>
                    <td>
                      Some Hydrologic Characteristics of the United States, Part
                      1
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1944</td>
                    <td>
                      Progress Report of Special Committee on Hydrologic Regions
                      of the United States 1943–44
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1945</td>
                    <td>
                      Infiltration and runoff during the snow-melting season,
                      with forest-cover
                    </td>
                    <td>Transactions of the American Geophysical Union</td>
                  </tr>
                  <tr>
                    <td>1945</td>
                    <td>
                      Erosional development of streams and their drainage
                      basins, hydrophysical approach to quantitative morphology
                    </td>
                    <td>Geological Society of America Bulletin</td>
                  </tr>
                  <tr>
                    <td>1945</td>
                    <td>
                      Fully Mechanized Farming on the Agronomic Unit Basis
                    </td>
                    <td>Soil Science Society of America Journal</td>
                  </tr>
                  <tr>
                    <td>1947</td>
                    <td>
                      Preliminary outline for a comprehensive research on runoff
                      phenomena
                    </td>
                    <td>W.R.C. Hydrologic Research</td>
                  </tr>
                  <tr>
                    <td>1948</td>
                    <td>The physics of thunderstorms</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1948</td>
                    <td>
                      Statistical distribution of drop sizes and the occurrence
                      of dominant drop sizes in rain
                    </td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1949</td>
                    <td>Convectional vortex rings – hail</td>
                    <td>
                      Transactions of the American Geophysical Union (T.A.G.U)
                    </td>
                  </tr>
                  <tr>
                    <td>1949</td>
                    <td>Hydrology Handbook</td>
                    <td>ASCE Manuals of Engineering Practice - No. 28</td>
                  </tr>
                  <tr>
                    <td>1949</td>
                    <td>Hydrology</td>
                    <td>Chapman and Hall</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="horton-cta">
              <a
                href="https://www.gofundme.com/f/hydrology-research-hortons-lost-works"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Learn More About the Horton Project
              </a>
              <a
                href="https://docs.google.com/document/d/14i1M6lsnaioLJjqzumUQahMo7hBzwut5X7-hPIhGlmA/edit?tab=t.0"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary"
                style={{ marginLeft: "1rem" }}
              >
                Read the Blog
              </a>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="team">
        <div className="container">
          <div className="section-title">
            <h2>Our Team</h2>
          </div>
          <div className="team-grid">
            <div className="team-card fade-in">
              <div className="team-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </div>
              <h4>Solomon Vimal</h4>
              <p>Founder and CEO</p>
              <p>PhD from UCLA (2022) in Hydro-Climate Science</p>
            </div>
            <div className="team-card fade-in">
              <div className="team-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </div>
              <h4>Ollie Bye</h4>
              <p>Founding Desinger</p>
              <p>Design and UI/UX Lead & Indie Youtuber</p>
            </div>
            <div className="team-card fade-in">
              <div className="team-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </div>
              <h4>Amandeep Singh</h4>
              <p>Founding Software Programmer</p>
              <p>Full Stack Development</p>
            </div>
            <div className="team-card fade-in">
              <div className="team-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </div>
              <h4>Sophia Zhu</h4>
              <p>Data Scientist and Software Intern</p>
              <p>UC San Diego Bio/Math/CS Major</p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="container">
          <div className="section-title">
            <h2>What do our customers and stakeholders say?</h2>
          </div>
          <div className="testimonial-slider">
            <Slide {...testimonialProperties}>
              <div className="testimonial-card fade-in">
                <span className="quote-icon">"</span>
                <div className="testimonial-content">
                  <p>
                    "I'm supremely grateful for the work! The insights provided
                    have transformed our research capabilities."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>Dr. Daniel Stein Kokin</h4>
                    <p>Project Director, All the Points</p>
                  </div>
                </div>
              </div>
              <div className="testimonial-card fade-in">
                <span className="quote-icon">"</span>
                <div className="testimonial-content">
                  <p>
                    "What you're developing with AI is highly valuable to the
                    community. The accuracy and speed of analysis is
                    remarkable."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>Dr. Ted Bohn</h4>
                    <p>WattIQ</p>
                  </div>
                </div>
              </div>
              <div className="testimonial-card fade-in">
                <span className="quote-icon">"</span>
                <div className="testimonial-content">
                  <p>
                    "This is a game changer. The platform has revolutionized how
                    we approach environmental data analysis."
                  </p>
                </div>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>Kai Barry</h4>
                    <p>Environmental Research Institute</p>
                  </div>
                </div>
              </div>
            </Slide>
          </div>
        </div>
      </section>

      <section className="partners">
        <div className="container">
          <div className="section-title">
            <h2>Our Partners</h2>
            <p className="section-subtitle">
              Collaborating with leading institutions to advance hydrological
              research and innovation
            </p>
          </div>
          <div className="partners-grid">
            <div className="partner-card-horizontal">
              <div className="partner-logo">
                <img src="/img/cornell-tech-logo.png" alt="Cornell Tech" />
              </div>
              <div className="partner-info">
                <h3>Cornell Tech</h3>
                <p>Research collaboration in hydrology and climate science</p>
              </div>
            </div>

            <div className="partner-card-horizontal">
              <div className="partner-logo">
                <img src="/img/ucla-logo-png.png" alt="UCLA" />
              </div>
              <div className="partner-info">
                <h3>University of California, Los Angeles</h3>
                <p>Research collaboration in hydrology and climate science</p>
              </div>
            </div>

            <div className="partner-card-horizontal">
              <div className="partner-logo">
                <img src="/img/Mira-fellowship.png" alt="MIRA Fellowship" />
              </div>
              <div className="partner-info">
                <h3>MIRA Fellowship Program</h3>
                <p>Supporting innovative research in environmental science</p>
              </div>
            </div>
          </div>

          <div className="partners-cta">
            <p>Interested in becoming a partner?</p>
            <a href="#contact" className="btn btn-secondary">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <section id="contact" className="contact">
        <div className="container">
          <div className="section-title">
            <h2>Contact Us</h2>
          </div>
          <div className="contact-grid">
            <div className="contact-info">
              <h3>Get In Touch</h3>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10z"
                    ></path>
                  </svg>
                </div>
                <div className="contact-text">
                  <h4>Email</h4>
                  <a href="mailto:contact@geothara.com">contact@geothara.com</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    ></path>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                  </svg>
                </div>
                <div className="contact-text">
                  <h4>Location</h4>
                  <p>Los Angeles, California</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
                <div className="contact-text">
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 9:00 AM - 6:00 PM PST</p>
                </div>
              </div>
            </div>
            <div className="contact-form">
              <form>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input type="text" id="company" className="form-control" />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone</label>
                  <input type="tel" id="phone" className="form-control" />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <select id="subject" className="form-control">
                    <option value="">Select a subject</option>
                    <option value="demo">Request Demo</option>
                    <option value="partnership">Partnership</option>
                    <option value="support">Technical Support</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    className="form-control"
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-primary">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <footer>
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <h3>Geothara</h3>
              <p>Data Science for Water, Energy and Climate Security</p>
            </div>
            <div className="footer-column">
              <h3>Services</h3>
              <ul>
                <li>
                  <a href="#">Data</a>
                </li>
                <li>
                  <a href="#">Analysis</a>
                </li>
                <li>
                  <a href="#">Mapping & Video</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3>About</h3>
              <ul>
                <li>
                  <a href="#">Company</a>
                </li>
                <li>
                  <a href="#">Team</a>
                </li>
                <li>
                  <a href="#">Horton Project</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3>Contact</h3>
              <ul>
                <li>
                  <a href="mailto:contact@geothara.com">contact@geothara.com</a>
                </li>
                <li>
                  <a href="#">Los Angeles, CA</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="copyright">
            <p>Copyright © Geothara 2025</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default PublicDashboard;
